//este archivo se supone que nos devuelve una array con los indices de los partidos que se juegan, a partir de una copa dada


const ttptr = (cup) => {
    let indicesDeLosGanadores = [];
    for(let i = 0; i < cup.equipos.length; i++) indicesDeLosGanadores.push(i)

    for(let i = 0; i < Math.floor(cup.currentRound / cup.gamesPerRound); i++){
      //si ronda actual es 0 no pasa por aqui (juegan todos), si es 1 solo pasa una vez (comprueba una ronda), si es 2 comprueba 2 rondas
      for(let j = 0; j < cup.equipos.length/(2**(i+1)); j++){
        //if j=0, comparame todo, if j=1, comparame la mitad, pero la mitad buena, asi que la primera comparacion guardamos incides
        const res1 = cup.equipos[indicesDeLosGanadores[j * 2]].results;
        const res2 = cup.equipos[indicesDeLosGanadores[1 + j * 2]].results;
        let contadorParaGanar1 = 0;
        for (let k = (i*cup.gamesPerRound); k < (i*cup.gamesPerRound)+cup.gamesPerRound; k++) if(JSON.parse(res1[k]) > JSON.parse(res2[k])) contadorParaGanar1++
        if (contadorParaGanar1 >= Math.ceil(cup.gamesPerRound/2)) indicesDeLosGanadores[j] = indicesDeLosGanadores[j * 2]
        else indicesDeLosGanadores[j] = indicesDeLosGanadores[1 + j * 2]
      }
      indicesDeLosGanadores = indicesDeLosGanadores.slice(0,indicesDeLosGanadores.length/2)
    }
    
    return indicesDeLosGanadores
}


export default ttptr